import { render, staticRenderFns } from "./Q3Edit.vue?vue&type=template&id=6d99461d&scoped=true&"
import script from "./Q3Edit.vue?vue&type=script&lang=js&"
export * from "./Q3Edit.vue?vue&type=script&lang=js&"
import style0 from "./Q3Edit.vue?vue&type=style&index=0&id=6d99461d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d99461d",
  null
  
)

export default component.exports